import React from "react";
import {
  PlusIcon,
  SearchIcon,
  CheckCircleIcon,
  XCircleIcon,
  PencilIcon,
  TrashIcon,
} from "@heroicons/react/solid";

const LoansTable = ({
  loans = [],
  onEdit,
  onDelete,
  onAdd,
  loading,
  onStatusChange,
}) => {
  return (
    <div>
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3 mb-4">
        <div className="relative w-full sm:w-auto">
          <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
          <input
            type="text"
            placeholder="Search Loan Products"
            className="bg-black border border-[#333333] rounded-full py-2 pl-10 pr-4 text-white w-full sm:w-64"
          />
        </div>

        <button
          onClick={onAdd}
          className="bg-[#FFCA20] hover:bg-yellow-600 text-black text-sm px-3 py-1.5 sm:px-4 sm:py-2 rounded flex justify-center sm:justify-start items-center font-medium w-full sm:w-auto"
        >
          <PlusIcon className="h-5 w-5 mr-1" /> Add Loan Product
        </button>
      </div>

      <div className="bg-[#131313] rounded-md overflow-x-auto scrollbar-hide">
        <table className="min-w-full divide-y divide-gray-800 text-sm overflow-x-auto">
          <thead className="border border-[#333333]">
            <tr className="bg-[#131313]">
              {/* <th className="px-4 py-3 text-left w-10">
                <input
                  type="checkbox"
                  className="h-4 w-4 rounded border-[#333333] text-[#FFCA20] focus:ring-yellow-500"
                />
              </th> */}
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider border-x border-[#333333] ">
                LOAN TYPE
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider border-x border-[#333333]">
                MIN-MAX AMOUNT
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider border-x border-[#333333]">
                ELIGIBILITY CRITERIA
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider border-x border-[#333333]">
                INTEREST RATE
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider border-x border-[#333333]">
                LINKED INSURANCE
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider border-x border-[#333333] rounded-tr-lg">
                STATUS
              </th>
            </tr>
          </thead>
          <tbody className="bg-[#131313] text-white">
            {loading ? (
              <tr>
                <td colSpan={7} className="text-center py-8 text-gray-400">
                  Loading...
                </td>
              </tr>
            ) : loans.length === 0 ? (
              <tr>
                <td colSpan={7} className="text-center py-8 text-gray-400">
                  No loans found.
                </td>
              </tr>
            ) : (
              loans.map((loan, idx) => (
                <tr key={loan.id} className="hover:bg-gray-800">
                  {/* <td className="px-4 py-3">
                    <input
                      type="checkbox"
                      className="h-4 w-4 rounded border-[#333333] text-[#FFCA20] focus:ring-yellow-500"
                    />
                  </td> */}
                  <td className="px-4 py-3 border-x border-[#333333] ">
                    {loan.loanType}
                  </td>
                  <td className="px-4 py-3 border-x border-[#333333] ">
                    ₹{loan.minAmount?.toLocaleString("en-IN")} - ₹
                    {loan.maxAmount?.toLocaleString("en-IN")}
                  </td>
                  <td
                    className="px-4 py-3 max-w-xs truncate border-x border-[#333333] "
                    title={loan.eligibility}
                  >
                    {loan.eligibility}
                  </td>
                  <td className="px-4 py-3 border-x border-[#333333] ">
                    {loan.interestRate}%
                  </td>
                  <td className="px-4 py-3 border-x border-[#333333] ">
                    {loan.linkedInsurance}
                  </td>
                  <td className="px-2 sm:px-4 py-3 border-x border-[#333333]">
                    <select
                      value={loan.status}
                      onChange={(e) =>
                        onStatusChange(loan, e.target.value, idx)
                      }
                      className={`w-full px-2 sm:px-3 py-1 rounded-md text-xs font-semibold transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-yellow-400 border shadow-sm
                        ${
                          loan.status === "Active"
                            ? "bg-green-50 text-green-700 border-green-300 hover:bg-green-100"
                            : "bg-red-50 text-red-700 border-red-300 hover:bg-red-100"
                        }
                      `}
                      style={{ cursor: "pointer" }}
                    >
                      <option value="Active">Active</option>
                      <option value="Closed">Closed</option>
                    </select>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LoansTable;
